const baseTypography = {
    fontFamily: 'aktiv-grotesk',
    fontWeight: '700',
    screenSizes: {
        large: '16px',
        medium: '16px',
        small: '16px',
    },
}

const smallTypography = {
    fontWeight: '400',
    screenSizes: {
        large: '12px',
        medium: '12px',
        small: '12px',
    },
}

export const SITE_VARIABLES = {
    COLORS: {
        DARK: '#999999',
        LIGHT: '#E5E5E5',
        LINK: '#9D2236',
        LIGHTWHITE: '#f9f9f9',
        GRAY: '#E5E5E5',
        MEDIUMGRAY: '#CCCCCC',
        DARKGRAY: '#999999',
        DARKGREY: '#222222',
        WHITE: '#f7f7f7',
        BLACK: '#000000',
        FsBlueDark: '#073759',
        FsBlueLight: '#5a94c1',
        PRIMARY: '#FF9900',
        SECONDARY: '#1B1B1B',
        BLUE: '#0A80C4',
    },
    TEXT_FONT_FAMILY: {
        DEFAULT: '"Montserrat", Arial, sans-serif',
        TITLE: '"Roboto", Arial, sans-serif',
    },
    FONT_SIZE: {
        H1: {
            fontSize: '1.2rem',
            '@media (min-width: 1024px)': {
                fontSize: '1.6rem',
            },
        },
        H3: {
            fontSize: '1rem',
        },
    },
    CSS_SELECTORS: {
        HOVER: '&:hover',
        AFTER: '&::after',
        BEFORE: '&::before',
    },
    BREAKPOINTS: [480, 768, 1024],
    TYPOGRAPHY: {
        bigger: baseTypography,
        large: baseTypography,
        big: baseTypography,
        normal: baseTypography,
        tiny: {
            ...baseTypography,
            ...smallTypography,
        },
    },
}

export const mq = SITE_VARIABLES.BREAKPOINTS.map((bp) => `@media (min-width: ${bp}px)`)
